import {baseRoute} from '../../../constants/routes';
export const CRUD_TYPE_ROUTE = baseRoute+'/personal-type';
export const CREATE_TYPE = 'CREATE_TYPE';
export const UPDATE_TYPE = 'UPDATE_TYPE';
export const DELETE_TYPE = 'DELETE_TYPE';
export const CREATE_TYPE_SUCCESS = 'CREATE_TYPE_SUCCESS';
export const UPDATE_TYPE_SUCCESS = 'UPDATE_TYPE_SUCCESS';
export const DELETE_TYPE_SUCCESS = 'DELETE_TYPE_SUCCESS';